module.exports = {
  address: "0x27B1D594B779086c8a2EEa14Ed3e63C7ABe7442D",
  abi: require("./DeviceStake.abi.json"),
  56: {
    address: "0x27B1D594B779086c8a2EEa14Ed3e63C7ABe7442D",
  },
};
